module.exports = __webpack_public_path__ + "img/photo-main.e5b49fea.webp";